export default {"src":"/_next/static/media/pico-pio.789a71b8.gif","height":209,"width":430,"blurWidth":0,"blurHeight":0};